/* eslint-disable no-restricted-globals */
/* eslint-disable array-callback-return */
import { Box, Grid } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { deleteClientFee, getClientBillingPoliciesByClientId, postClientBillingPolicy, postClientFee, updateClientBillingPolicy, updateClientFee } from 'modules/clients/clients.actions';
import { DELETE_CLIENT_FEE_FAILURE, GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_FAILURE, POST_CLIENT_FEE_FAILURE, UPDATE_CLIENT_BILLING_POLICY_FAILURE, UPDATE_CLIENT_FEE_FAILURE } from 'modules/clients/types';
import SpinnerComponent from 'modules/common/spinner.component';
import { showToast } from 'modules/layout/layout.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import CrudTable from '../crudTable.component';
import { enumColumn } from 'modules/common/enumTableColumn';

const BillingPolicyDetails = ({ policyDetails, prebuiltTriggers, clientPolicyStatuses, updateClientBillingPolicy, getClientBillingPoliciesByClientId, showToast, feeFrequencies, clientFeeTriggerFields, feeTriggerValues, updateClientFee, postClientFee, deleteClientFee, expenseCodes, isReadOnly }) => {

  const [billingPolicyDescription, setBillingPolicyDescription] = useState(policyDetails.billingPolicy.billingPolicyDescription || '');
  const [clientPolicyStatusId, setClientPolicyStatusId] = useState(policyDetails.billingPolicy.clientPolicyStatusId || '00000000-0000-0000-0000-000000000000');

  const [isLoading, setIsLoading] = useState(false);
  const [feeList, setFeeList] = useState(policyDetails.fees);
  const selectedBillingPolicyId = policyDetails?.billingPolicy?.billingPolicyId;

  const refreshFeeList = async () => {
    const response = await getClientBillingPoliciesByClientId(policyDetails.billingPolicy.clientRecordId);
    if (response.type === GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_FAILURE) return false;

    const refreshedPolicy = response.response?.find(
      policy => String(policy.billingPolicy.billingPolicyId) === String(selectedBillingPolicyId)
    );
    if (!refreshedPolicy) return false;

    setFeeList(refreshedPolicy.fees || []);
    return true;
  };

  let mappedTriggerFields = [];
  clientFeeTriggerFields.map((cftf) => {
    mappedTriggerFields.push({
        id: cftf.triggerFieldId,
        title: `${cftf.tableDisplayName} - ${cftf.fieldDisplayName}`
    });
  });

  let prebuiltTriggerOptions = prebuiltTriggers && prebuiltTriggers.length > 0 ? prebuiltTriggers.map((pt) => {
    return {
      id: pt.prebuiltTriggerId,
      title: pt.prebuiltTriggerId === 1 ? 'Homesale Referral Trigger' : 'Homefind Referral Trigger'
    };
  }) : [];

  const mapFeeRuleTriggers = (fee) => {
    let triggers = [];
    if (fee.customTriggers) {
        fee.customTriggers.map((trigger) => {
            triggers.push(
                {
                    ...trigger,
                    categoryType: 'customTrigger'
                }
                );
        });
    }
    if (fee.prebuiltTriggers) {
        fee.prebuiltTriggers.map((trigger) => {
            triggers.push({
                ...trigger,
                categoryType: 'prebuiltTrigger'
            });
        });
    }
    return triggers;
}

  const mappedFeeList = useMemo(() => {
    return (feeList || [])
      .filter(fee => String(fee?.feeRule?.clientBillingPolicyId) === String(selectedBillingPolicyId))
      .map((fee) => {
        return {
          clientFeeId: fee.feeRule.clientFeeId,
          feeLineDescription: fee.feeRule.feeLineDescription,
          isPercentage: fee.feeRule.isPercentage ? fee.feeRule.isPercentage : false,
          feeAmount: fee.feeRule.feeAmount != null ? fee.feeRule.feeAmount.toString() : '',
          expenseCodeId: fee.feeRule.expenseCodeId,
          ratePercentage: fee.feeRule.ratePercentage != null ? fee.feeRule.ratePercentage : 0,
          feeFrequencyId: fee.feeRule.feeFrequencyId,
          feeTriggers: mapFeeRuleTriggers(fee)
        };
      });
  }, [feeList, selectedBillingPolicyId]);

  const categories = [
    { id: 0, title: 'feeSummary' },
    { id: 1, title: 'feeTriggers' }
  ];

  const feeTriggerAfter = [
    { id: 0, title: '0 days' },
    { id: 1, title: '1 day' },
    { id: 2, title: '15 days' },
    { id: 3, title: '30 days' },
    { id: 4, title: '60 days' },
    { id: 5, title: '90 days' },
    { id: 6, title: '180 days' },
  ];

  const ratePercentageOptions = [
    { id: 0, title: 'Offer Accepted Amount' },
    { id: 1, title: 'Appraised Value Average' },
  ];

  const customTriggerFormFields = [
    {
      name: 'feeTriggerFieldId',
      type: 'dropdown-v2',
      options: mappedTriggerFields,
      label: 'Fee Trigger Field',
      },
    {
      name: 'feeTriggerValueId',
      type: 'dropdown-v2',
      options: feeTriggerValues,
      label: 'Fee Trigger Value',
      },
    { name: 'feeTriggerAfterId', type: 'dropdown-v2', options: feeTriggerAfter, label: 'Trigger After' },
    { name: 'isFeeTriggerManual', type: 'checkbox', label: 'Is Fee Trigger Manual' }
  ];

  const prebuiltTriggerFormFields = [
    {
      name: 'prebuiltTriggerId',
      type: 'dropdown-v2',
      options: prebuiltTriggerOptions,
      label: 'Prebuilt Trigger',
    },
    ];
  
  const formLabel = 'Triggers';
  const triggerHeader = { title: 'Triggers' };
  const createNewCustomTriggerRowFunc = () => {
    return {
      feeTriggerFieldId: 0,
      feeTriggerValueId: 0,
      feeTriggerAfterId: 0,
      isFeeTriggerManual: false,
      categoryType: 'customTrigger'
    };
  };
  const createNewPrebuiltTriggerRowFunc = () => {
    return {
      prebuiltTriggerId: 0,
      categoryType: 'prebuiltTrigger'
    };
  };
  const checkIfTriggers = (triggers) => {
    if (triggers && triggers.length > 0) {
        return false;
    }
    return true;
  }

  const uniqueExpenseCodes = useMemo(() => {
    const seenIds = new Set();
    return (expenseCodes || []).filter((expenseCode) => {
      const id = expenseCode?.expenseCodeCode;
      if (id == null || seenIds.has(id)) {
        return false;
      }
      seenIds.add(id);
      return true;
    });
  }, [expenseCodes]);

  const expenseCodesSearchInfo = {
    searchingColumns: [
      { name: 'expenseCodeId', title: 'Expense Code Id' },
      { name: 'expenseCodeCode', title: 'Expense Code' },
      { name: 'expenseCodeDescription', title: 'Description' },
      { name: 'category', title: 'Category' }
    ],
    searchingColumnExtensions: [
      { columnName: 'expenseCodeId', width: 150 },
      { columnName: 'expenseCodeCode', width: 150 },
      { columnName: 'expenseCodeDescription', width: 200 },
      { columnName: 'category', width: 175 },
    ],
    searchingRows: uniqueExpenseCodes,
    idKey: 'expenseCodeId',
    nameKey: 'expenseCodeCode'
  };
  let selectedExpenseCodeId = mappedFeeList && mappedFeeList.length > 0 ? mappedFeeList[0].expenseCodeId : 0;
  let selectedExpenseCode = null;
  
  if(uniqueExpenseCodes && uniqueExpenseCodes.length > 0) {
    selectedExpenseCode = uniqueExpenseCodes.find((ec) => ec.expenseCodeId === selectedExpenseCodeId);
  }
  
  const addButtons = [
    { id: 0, addFormRow: createNewPrebuiltTriggerRowFunc, addRowLabel: 'Add Prebuilt Trigger', categoryType: 'prebuiltTrigger', formFields: prebuiltTriggerFormFields },
    { id: 1, addFormRow: createNewCustomTriggerRowFunc, addRowLabel: 'Add Custom Trigger', categoryType: 'customTrigger', formFields: customTriggerFormFields }
  ];

  const adjustedColumns = [
        { accessorKey: 'clientFeeId', header: 'Fee Id', type: 'number', hideInModel: false, disabled: true, size: 25, categoryType: 'feeSummary', hideInTable: true, hideInModal: true},
        { accessorKey: 'feeLineDescription', header: 'Description', type: 'text', required: true, size: 50, categoryType: 'feeSummary' },
        { header: 'Expense Code',
              accessorKey: 'expenseCodeId',
              nameKey: 'expenseCodeCode',
              nameValue: selectedExpenseCode ? selectedExpenseCode.expenseCodeCode : '',
              type: 'advanced-search',
              searchInfo: expenseCodesSearchInfo,
              value: selectedExpenseCode ? selectedExpenseCode.expenseCodeId : 0,
              tab: 1,
              categoryType: 'feeSummary',
              size: 50,
        },
        { accessorKey: 'isPercentage', header: 'Is Percentage', type: 'checkbox', required: false, size: 25, hideInTable: true, categoryType: 'feeSummary' },
        { accessorKey: 'feeAmount', header: 'Fee Amount', type: 'money', required: false, dependentOn: 'isPercentage', dependentValue: false, size: 25, categoryType: 'feeSummary' },
        { accessorKey: 'ratePercentage', header: 'Percentage Base Rate', type: 'dropdown-v2', options: ratePercentageOptions, dependentOn: 'isPercentage', dependentValue: true, required: false, size: 25, hideInTable: true, categoryType: 'feeSummary' },
        { ...enumColumn('feeFrequencyId', feeFrequencies), header: 'Fee Frequency', type: 'dropdown-v2', options: feeFrequencies, required: true, size: 40, categoryType: 'feeSummary', Cell: ({ cell }) => cell.getValue() && <p>{cell.getValue()}</p> },
        { accessorKey: 'feeTriggers', header: triggerHeader, type: 'multi-row-form', addButtons: addButtons, formLabel: formLabel, formFields: customTriggerFormFields, required: false, size: 100, hideInTable: true, categoryType: 'feeTriggers', }
];

  const savePolicy = async () => {
    let newValues = {...policyDetails.billingPolicy};
    setIsLoading(true);

    newValues.billingPolicyDescription = billingPolicyDescription;
    newValues.clientPolicyStatusId = clientPolicyStatusId;

    const resp = await updateClientBillingPolicy(newValues);
    if (resp.type === UPDATE_CLIENT_BILLING_POLICY_FAILURE) {
        showToast('Failed to save policy, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
    } else {
        const getResp = await getClientBillingPoliciesByClientId(policyDetails.billingPolicy.clientRecordId);
        if (getResp.type === GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_FAILURE) {
            setIsLoading(false);
            return false;
        } else {
            setIsLoading(false);
            showToast('Successfully saved policy changes.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
            return true;
        }
    }
  }

  const deletePolicy = async () => {
      // if (!confirm(`Are you sure you want to delete policy ${policyDetails.billingPolicy.billingPolicyId}?`)) {
      //   return;
      // }

      setIsLoading(true);
      const newValues = {
        ...policyDetails.billingPolicy,
        clientPolicyStatusId: policyDetails.billingPolicy.clientPolicyStatusId === clientPolicyStatuses.find(status => status.title === 'Active')?.id 
        ? clientPolicyStatuses.find(status => status.title === 'Inactive')?.id : clientPolicyStatuses.find(status => status.title === 'Active')?.id
      };
      const resp = await updateClientBillingPolicy(newValues);
      if (resp.type === UPDATE_CLIENT_BILLING_POLICY_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        const getResp = await getClientBillingPoliciesByClientId(policyDetails.billingPolicy.clientRecordId);
        if (getResp.type === GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_FAILURE) {
          setIsLoading(false);
          return false;
        } else {
          setIsLoading(false);
          return true;
        }
      }
  };

  const postFee = async (values) => {

    let customTriggers = values.feeTriggers ? values.feeTriggers.filter((trigger) => trigger.categoryType === 'customTrigger') : [];
    let prebuiltTriggers = values.feeTriggers ? values.feeTriggers.filter((trigger) => trigger.categoryType === 'prebuiltTrigger') : [];

    let newValues = {
        feeRule: {
            clientFeeId: 0,
            clientBillingPolicyId: policyDetails.billingPolicy.billingPolicyId,
            feeLineDescription: values.feeLineDescription,
            isPercentage: values.isPercentage && values.isPercentage !== '' ? values.isPercentage : false,
            feeAmount: values.feeAmount ? values.feeAmount : null,
            expenseCodeId: values.expenseCodeId,
            ratePercentage: values.ratePercentage ? values.ratePercentage : null,
            feeFrequencyId: values.feeFrequencyId,
            addedBy: 0, addedOn: new Date(), modifiedBy: 0, modifiedOn: new Date()
        },
        customTriggers: customTriggers && customTriggers.length > 0 ? customTriggers.map((trigger) => { return {
            clientFeeTriggerCustomId: 0,
            clientFeeId: 0,
            feeTriggerAfterId: trigger.feeTriggerAfterId, 
            feeTriggerValueId: trigger.feeTriggerValueId, 
            feeTriggerFieldId: trigger.feeTriggerFieldId, 
            isFeeTriggerManual: trigger.isFeeTriggerManual, 
            addedBy: 0, addedOn: new Date(), modifiedBy: 0, modifiedOn: new Date()}; } ) : [],
        prebuiltTriggers: prebuiltTriggers && prebuiltTriggers.length > 0 ? prebuiltTriggers.map((trigger) => { return { 
            clientFeeTriggerPrebuiltId: 0,
            clientFeeId: 0,
            prebuiltTriggerId: trigger.prebuiltTriggerId, 
            addedBy: 0, addedOn: new Date(), modifiedBy: 0, modifiedOn: new Date()}; } ) : []
    };

    const resp = await postClientFee(newValues);
    if (resp.type === POST_CLIENT_FEE_FAILURE) {
        showToast('Failed to save fee, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return false;
    } else {
        if (!(await refreshFeeList())) {
          showToast('Fee saved, but failed to refresh fees. Please reload the billing policy.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          return false;
        }
        showToast('Successfully saved fee changes.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        return true;
    }
  };

  const updateFee = async (updatedFee, values) => {
    const id = updatedFee.original.clientFeeId;
    const feeToUpdate = feeList.find((fee) => fee.feeRule.clientFeeId === id);

    let customTriggers = values.feeTriggers ? values.feeTriggers.filter((trigger) => trigger.categoryType === 'customTrigger') : [];
    let prebuiltTriggers = values.feeTriggers ? values.feeTriggers.filter((trigger) => trigger.categoryType === 'prebuiltTrigger') : [];
      

    let newValues = {
        feeRule: {
            clientFeeId: id,
            clientBillingPolicyId: policyDetails.billingPolicy.billingPolicyId,
            feeLineDescription: values.feeLineDescription,
            isPercentage: values.isPercentage && values.isPercentage !== '' ? values.isPercentage : false,
            feeAmount: values.feeAmount ? values.feeAmount : null,
            expenseCodeId: values.expenseCodeId,
            ratePercentage: values.ratePercentage ? values.ratePercentage : null,
            feeFrequencyId: values.feeFrequencyId,
            addedBy: feeToUpdate.feeRule.addedBy, addedOn: feeToUpdate.feeRule.addedOn, modifiedBy: 0, modifiedOn: new Date()
        },
        customTriggers: customTriggers && customTriggers.length > 0 ? customTriggers.map((trigger) => { 
            return {
            clientFeeTriggerCustomId: trigger.clientFeeTriggerCustomId ? trigger.clientFeeTriggerCustomId : 0,
            clientFeeId: id,
            feeTriggerAfterId: trigger.feeTriggerAfterId, 
            feeTriggerValueId: trigger.feeTriggerValueId, 
            feeTriggerFieldId: trigger.feeTriggerFieldId, 
            isFeeTriggerManual: trigger.isFeeTriggerManual, 
            addedBy: feeToUpdate.customTriggers.filter(t => t.clientFeeTriggerCustomId === trigger.clientFeeTriggerCustomId)[0] ? trigger.addedBy : 0, 
            addedOn: feeToUpdate.customTriggers.filter(t => t.clientFeeTriggerCustomId === trigger.clientFeeTriggerCustomId)[0] ? trigger.addedOn : new Date(), 
            modifiedBy: 0, modifiedOn: new Date()}; } ) : [],
        prebuiltTriggers: prebuiltTriggers && prebuiltTriggers.length > 0 ? prebuiltTriggers.map((trigger) => { return { 
            clientFeeTriggerPrebuiltId: trigger.clientFeeTriggerPrebuiltId ? trigger.clientFeeTriggerPrebuiltId : 0,
            clientFeeId: id,
            prebuiltTriggerId: trigger.prebuiltTriggerId, 
            addedBy: feeToUpdate.prebuiltTriggers.filter(t => t.clientFeeTriggerPrebuiltId === trigger.clientFeeTriggerPrebuiltId)[0] ? trigger.addedBy : 0, 
            addedOn: feeToUpdate.prebuiltTriggers.filter(t => t.clientFeeTriggerPrebuiltId === trigger.clientFeeTriggerPrebuiltId)[0] ? trigger.addedOn : new Date(),
             modifiedBy: 0, modifiedOn: new Date()}; } ) : []
    };

    const resp = await updateClientFee(newValues);
    if (resp.type === UPDATE_CLIENT_FEE_FAILURE) {
        showToast('Failed to save fee, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return false;
    } else {
        if (!(await refreshFeeList())) {
          showToast('Fee saved, but failed to refresh fees. Please reload the billing policy.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          return false;
        }
        showToast('Successfully saved fee changes.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        return true;
    }
  };

  const deleteFee = async (feeToDelete) => {
    const id = feeToDelete.original.clientFeeId;
    const billingPolicyId = policyDetails.billingPolicy.billingPolicyId;
    const resp = await deleteClientFee(id, billingPolicyId);
    if (resp.type === DELETE_CLIENT_FEE_FAILURE) {
      showToast('Failed to delete fee, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    } else {
        if (!(await refreshFeeList())) {
          showToast('Fee deleted, but failed to refresh fees. Please reload the billing policy.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          return false;
        }
        showToast('Successfully saved fee changes.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      return true;
    }
  }

  useEffect(() => {
    if (policyDetails) {
        setBillingPolicyDescription(policyDetails.billingPolicy.billingPolicyDescription || '');
        setClientPolicyStatusId(policyDetails.billingPolicy.clientPolicyStatusId || '00000000-0000-0000-0000-000000000000');
        setFeeList(policyDetails.fees || []);
    }
  }, [policyDetails]);

  return (
    <Box sx={{ padding: '10px' }}>
        <Card sx={{ position: 'relative', width: '100%', flexGrow: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Box>
                <CardContent sx={{ maxWidth: '100% !important', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <div className="row justify-space-between align-center">
                        <Box sx={{display: 'flex', flexDirection: 'row'}}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '20px'
                                }}
                            >
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '1.3125rem',
                                    fontWeight: 'bold'
                                }}
                            >
                                Billing Policy {policyDetails.billingPolicy.billingPolicyId}
                            </Typography>
                            </Box>
                        </Box>
                    </div>
                </CardContent>
                <CardContent sx={{ padding: '10px', marginLeft: '30px' }}>
                    <Grid container spacing={2} columns={{ xs: 3 }}>
                        <Grid item sx={{ margin: '0 20px' }}>
                            <TextField
                                label="Billing Policy Description"
                                name="billingPolicyDescription"
                                value={billingPolicyDescription}
                                margin="dense"
                                sx={{ maxWidth: '360px' }}
                                variant="standard"
                                type="text"
                                onChange={(e) => setBillingPolicyDescription(e.target.value)}
                            />
                        </Grid>
                        <Grid item sx={{ margin: '0 20px' }}>
                            <FormControl sx={{ marginTop: '6px' }}>
                                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Billing Policy Status</InputLabel>
                                <Select
                                    label="Currency"
                                    name="clientPolicyStatusId"
                                    value={clientPolicyStatusId}
                                    variant="standard"
                                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                                    onChange={(e) => setClientPolicyStatusId(e.target.value)}
                                >
                                    {clientPolicyStatuses.map(opt => (
                                        <MenuItem key={opt.id} value={opt.id}>
                                            {opt.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardContent sx={{ padding: '10px', marginLeft: '30px' }}>
                    <Box sx={{marginBottom: '16px'}}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontSize: '1rem',
                                fontWeight: 'bold'
                            }}
                        >
                            Fees
                        </Typography>
                    </Box>

                    <CrudTable 
                        editingMode={'modal'} // Can be changed to 'row' to edit inline 
                        hideEdit={isReadOnly}
                        columns={adjustedColumns} 
                        rows={mappedFeeList ? mappedFeeList : []} 
                        updateRow={updateFee} 
                        createRow={postFee} 
                        deleteRow={deleteFee} 
                        enableColumnOrdering={false}
                        enableColumnResizing={false}
                        enableColumnFilters={false}
                        categories={categories}
                        isDirtyLogic={checkIfTriggers}
                        isDirtyField={"feeTriggers"}
                    />
                </CardContent>
                <CardContent>
                    <Box sx={{ paddingLeft: '16px', display: 'flex', flexDirection: 'row', gap: '10px', marginTop: '20px', justifyContent: 'flex-end' }}>
                        {!isLoading && (
                            <>
                              {policyDetails.billingPolicy.clientPolicyStatusId === clientPolicyStatuses.find(status => status.title === 'Active')?.id ? (
                                <Button color="primary" onClick={deletePolicy} disabled={isReadOnly} variant="outlined">
                                    Set Inactive
                                </Button>
                              ) : (
                                <Button color="primary" onClick={deletePolicy} disabled={isReadOnly} variant="outlined">
                                    Set Active
                                </Button>
                              )}
                                <Button color="primary" onClick={savePolicy} variant="contained" disabled={isReadOnly}>
                                    Save
                                </Button>
                            </>
                        )}
                        {isLoading && <SpinnerComponent/>}
                    </Box>
                </CardContent>
            </Box>
        </Card>
    </Box>
  );  
};

const mapStateToProps = state => {
  const { clientDetails } = state.clients.clientsInfo[state.clients.currentClientId];
  const { clientPolicyStatuses, feeFrequencies, feeTriggerValues } = state.enumerations.allEnums;
  
  return {
    clientDetails,
    clientPolicyStatuses,
    feeFrequencies,
    feeTriggerValues,
  };
};
  
export default compose(
  connect(mapStateToProps, {
    getClientBillingPoliciesByClientId,
    postClientBillingPolicy,
    updateClientBillingPolicy,
    showToast,
    postClientFee,
    updateClientFee,
    deleteClientFee
  }),
)(BillingPolicyDetails);